import React, { useState } from 'react';
import Navbar from '../navbar';
import TopNavbar from '../topnavbar';
import Footer from '../footer';
import '../../App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendEmail } from '../globalFunctions'; 

function SSSLoan() {

    const EmployeeId = sessionStorage.getItem("employeeId");

    const [thisInfo, setSSSinfo] = useState({
        Application_Date: '',
        Transaction_Number: '', // Keep it as string for input handling
        Pay_Slip: '',
        Pay_Slip_2: '',
        SSSLoanWaiver: '',
    });

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const isValidFileType = (file) => {
            const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
            return allowedTypes.includes(file.type);
        };

        // Check if Application_Date is empty
        if (!thisInfo.Application_Date) {
            document.getElementById('loanApplicationDate').style.border = '1px solid red';
            toast.error('Loan Application Date is required.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return; // Stop further execution
        } else {
            document.getElementById('loanApplicationDate').style.border = '';
        }

        const formData = new FormData();
        formData.append('currentEmployeeId', EmployeeId);
        formData.append('Application_Date', thisInfo.Application_Date);

        // Check if Transaction_Number is a valid integer
        if (thisInfo.Transaction_Number && thisInfo.Transaction_Number.length >= 20) {
            formData.append('Transaction_Number', thisInfo.Transaction_Number);
            document.getElementById('TransactionNum').style.border = '';
        } else {
            document.getElementById('TransactionNum').style.border = '1px solid red';
            toast.error('Something went wrong. Please check your Transaction Number where it should have 20 or more characters.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return; // Stop further execution
        }

        // Validate and append Pay Slip
        if (thisInfo.Pay_Slip && isValidFileType(thisInfo.Pay_Slip)) {
            formData.append('Pay_Slip', thisInfo.Pay_Slip);
            document.getElementById('PaySlipInvalid').style.border = '';
        } else {
            document.getElementById('PaySlipInvalid').style.border = '1px solid red';
            toast.error('Invalid file type. Please check your file you uploaded.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return; // Stop further execution
        }

        // Validate and append Disclosure Statement
        if (thisInfo.Pay_Slip_2 && isValidFileType(thisInfo.Pay_Slip_2)) {
            formData.append('Pay_Slip_2', thisInfo.Pay_Slip_2);
            document.getElementById('PaySlip2Invalid').style.border = '';
        } else {
            document.getElementById('PaySlip2Invalid').style.border = '1px solid red';
            toast.error('Invalid file type. Please check your file you uploaded.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return; // Stop further execution
        }

        if (thisInfo.SSSLoanWaiver && isValidFileType(thisInfo.SSSLoanWaiver)) {
            formData.append('SSSLoanWaiver', thisInfo.SSSLoanWaiver);
            document.getElementById('SSSLoanWaiverInvalid').style.border = '';
        } else {
            document.getElementById('SSSLoanWaiverInvalid').style.border = '1px solid red';
            toast.error('Invalid file type. Please check your file you uploaded.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return; // Stop further execution
        }

        try {
            const response = await fetch('/api/SSSloan', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const jsonResponse = await response.json();

                console.log(jsonResponse);

                setSSSinfo({
                    Application_Date: '',
                    Transaction_Number: '',
                    Pay_Slip: '',
                    Pay_Slip_2: ''
                });

                // Clear file input fields
                document.getElementById('loanApplicationDate').value = null;
                document.getElementById('TransactionNum').value = null;
                document.getElementById('PaySlip').value = null;
                document.getElementById('PaySlip2').value = null;
                document.getElementById('SSSLoanWaiver').value = null;

                sendEmailNotification()
                
                // Emit success toast
                toast.success('Thank you! Your request has been submitted.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

            } else {
                const errorResponse = await response.json();
                console.error('Failed to submit request:', response.statusText);
                toast.error(errorResponse.message || 'Failed to Submit', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.error('Error uploading:', error);
        }
    };

    const handlePay_Slip = (e) => {
        setSSSinfo({ ...thisInfo, Pay_Slip: e.target.files[0] });
    };

    const handlePay_Slip_2 = (e) => {
        setSSSinfo({ ...thisInfo, Pay_Slip_2: e.target.files[0] });
    };

    const handleSSSLoanWaiver = (e) => {
        setSSSinfo({ ...thisInfo, SSSLoanWaiver: e.target.files[0] });
    };

    const handleLoanApplicationDateChange = (e) => {
        setSSSinfo({ ...thisInfo, Application_Date: e.target.value });
    };

    const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        let month = now.getMonth() + 1;
        let day = now.getDate();

        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }

        return `${year}-${month}-${day}`;
    };
    const sendEmailNotification = () => {
        
        const content = {
            HrName: '',
            HrEmail: '', 
            Name: sessionStorage.getItem("firstName") + " " + sessionStorage.getItem("lastName"),
            EmailAddress: sessionStorage.getItem("email"), 
            TransactionType: 'SSS Loan',
            documentName: '',
            reason: '',
            stopDeduction: false,
            facility: sessionStorage.getItem("facility")
        }; 

        if (sessionStorage.getItem("email")) {
            sendEmail('submit', content);
        }
    };
    return (
        <div id="wrapper">
            <Navbar />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopNavbar />
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <h4 className="m-0 font-weight-bold text-primary header-name">SSS Loan</h4>
                        </div>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        {/* page content begin here */}
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-xl-8 col-lg-7">
                                    <div className="card shadow mb-4">
                                        {/* Card Header - New Hire Upload */}
                                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                            <h6 className="m-0 font-weight-bold text-primary">Loan Details</h6>
                                        </div>
                                        {/* Card Body - New Hire Options */}
                                        <div className="card-body">
                                            <div className="tab-content">
                                                <div className="card-body loan-row">
                                                    {/* Loan Application Date */}
                                                    <div className="form-group">
                                                        <label>Loan Application Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            id="loanApplicationDate"
                                                            name="loanApplicationDate"
                                                            max={getCurrentDate()}
                                                            value={thisInfo.Application_Date}
                                                            onChange={handleLoanApplicationDateChange}
                                                        />
                                                    </div>

                                                    {/* Transaction Number */}
                                                    <div className="form-group">
                                                        <label htmlFor="TransactionNum">Transaction Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="TransactionNum"
                                                            name="TransactionNum"
                                                            minLength={20}
                                                            value={thisInfo.Transaction_Number}
                                                            onChange={(e) =>
                                                                setSSSinfo({ ...thisInfo, Transaction_Number: e.target.value })
                                                            }
                                                        />
                                                    </div>

                                                    {/* Guide Link */}
                                                    <div className="text-end">
                                                        <a
                                                            href="https://innodata.sharepoint.com/:f:/s/HR-TOOLS/IgA8M3yT6vpjQZ9-IC0XsCbXAYfPoCbru7CoKs1Djykqhb4?e=ahI4da"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                                                        >
                                                            Click to see guide on how to file a loan.
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Page content ends here */}
                        
                        {/* page content begin here */}
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-xl-8 col-lg-7">
                                    <div className="card shadow mb-4">
                                        {/* Card Header - New Hire Upload */}
                                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                            <h6 className="m-0 font-weight-bold text-primary">1st Cut-Off Pay Slip</h6>
                                        </div>
                                        {/* Card Body - New Hire Options */}
                                        <div className="card-body" id='PaySlipInvalid'>
                                            <div className="tab-content">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-left">
                                                        <input
                                                            type="file"
                                                            className="input-file"
                                                            aria-describedby="fileHelp"
                                                            onChange={handlePay_Slip}
                                                            id='PaySlip'
                                                        />
                                                    </div>
                                                    
                                                    {/* Guide Link */}
                                                    <div className="text-end mt-3">
                                                        <a
                                                            href="https://innodataiksi.stohrm.com"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                                                        >
                                                            Click to see guide on how to download payslips from Stohrm.
                                                        </a>
                                                    </div>
                                                    <br/>
                                                    <label style={{ fontSize: '12px'}}><b>Reminder:</b> Please ensure that you submit the unedited/original copy of your payslip. 
                                                    Do not alter, crop, or modify the file in any way before submission. Edited files may result in delays or rejection of your submission.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Page content ends here */}
                        {/* page content begin here */}
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-xl-8 col-lg-7">
                                    <div className="card shadow mb-4">
                                        {/* Card Header - New Hire Upload */}
                                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                            <h6 className="m-0 font-weight-bold text-primary">2nd Cut-Off Pay Slip</h6>
                                        </div>
                                        {/* Card Body - New Hire Options */}
                                        <div className="card-body" id='PaySlip2Invalid'>
                                            <div className="tab-content">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-left">
                                                        <input
                                                            type="file"
                                                            className="input-file"
                                                            aria-describedby="fileHelp"
                                                            onChange={handlePay_Slip_2}
                                                            id='PaySlip2'
                                                        />
                                                    </div>
                                                    {/* Guide Link */}
                                                    <div className="text-end mt-3">
                                                        <a
                                                            href="https://innodataiksi.stohrm.com"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                                                        >
                                                            Click to see guide on how to download payslips from Stohrm.
                                                        </a>
                                                    </div>
                                                    <br/>
                                                    <label style={{ fontSize: '12px'}}><b>Reminder:</b> Please ensure that you submit the unedited/original copy of your payslip. 
                                                    Do not alter, crop, or modify the file in any way before submission. Edited files may result in delays or rejection of your submission.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Page content ends here */}
                        
                        {/* page content begin here */}
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-xl-8 col-lg-7">
                                    <div className="card shadow mb-4">
                                        {/* Card Header - New Hire Upload */}
                                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                            <h6 className="m-0 font-weight-bold text-primary">SSS Loan Waiver</h6>
                                        </div>
                                        {/* Card Body - New Hire Options */}
                                        <div className="card-body" id='SSSLoanWaiverInvalid'>
                                            <div className="tab-content">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-left">
                                                        <input
                                                            type="file"
                                                            className="input-file"
                                                            aria-describedby="fileHelp"
                                                            onChange={handleSSSLoanWaiver}
                                                            id='SSSLoanWaiver'
                                                        />
                                                    </div>
                                                    {/* Guide Link */}
                                                    <div className="text-end mt-3">
                                                        <a
                                                            href="https://innodata-my.sharepoint.com/:b:/p/zax/ES8lRt2kiR1KguXAJPeQ9moBPPqP7XfiznaAdfQEUOkuXw"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                                                        >
                                                            Download Waiver Template
                                                        </a>
                                                    </div>
                                                    <br/>
                                                    <label style={{ fontSize: '12px'}}><b>Instruction:</b> Please upload a fully accomplished copy of the SSS Loan Waiver. You may refer to the attached link for the form. </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Page content ends here */}
                        <label style={{ fontSize: '12px', marginLeft: '310px', width: '100%'}}>Note: File upload only accepts PDF, PNG, or JPEG file.</label>
                        <br /><br />
                        <button type="submit" className="btn btn-primary d-block mx-auto loan-btn">Submit</button>
                    </form>
                </div>
                <Footer />
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

export default SSSLoan;